import type { UUID } from '@/types/Id'

export type StageEstimatedValue = {
  stage_id: UUID
  estimated_value: number
}

export type PursuitEstimatedValueSummary = {
  stages: StageEstimatedValue[]
  null_or_zero_count: number
}

interface PursuitEstimatedValueSummaryQueryKeyArgs {
  orgId: UUID | ''
}

export const pursuitEstimatedValueSummaryQueryKeys = {
  all: () => ['pursuit-estimated-value-summary'] as const,
  organization: (keyArgs: PursuitEstimatedValueSummaryQueryKeyArgs) =>
    ['pursuit-estimated-value-summary', keyArgs.orgId] as const,
}
